export enum DialogType {
	Normal = 'normal',
	BottomSheet = 'bottom-sheet',
}
